export default "__VITE_ASSET__eIDUziiD__"